import React from "react"
import { Flex, FlexProps, Box } from "@chakra-ui/core"
import { Filter, toggleSelected } from "./utils"
import DropDownSelector from "../../components/DropDownSelector"

type DesktopFiltersProps = FlexProps & {
  filters: Filter[]
  setFilters: (filters: Filter[]) => void
}

export default function DesktopFilters({
  filters,
  setFilters,
  children,
  ...props
}: DesktopFiltersProps) {
  return (
    <Flex flexWrap="wrap" gridRowGap="0.5rem" {...props}>
      {filters?.map((f) => (
        <Box as="span" key={f.title}>
          <DropDownSelector
            title={
              f.title == "wheelSize"
                ? "Wheel size"
                : f.title.charAt(0).toUpperCase() + f.title.slice(1)
            }
            options={f.options
              //remove duplicate
              .filter(
                (v, i, a) => a.findIndex((v2) => v2.name === v.name) === i
              )
              .filter((opt) => {
                return opt.name
              })}
            onOptionSelected={(name) => {
              toggleSelected(f.title, name, filters, setFilters)
            }}
            menuListProps={{
              zIndex: 20,
              maxH: "50vh",
              overflow: "auto",
            }}
            isDisabled={f.options.length === 0}
            showChevron
          />
        </Box>
      ))}
      {children}
    </Flex>
  )
}
